/**
 * The /settings search params and the section list they are checked against.
 *
 * Apart from the page for the same reason W-06's and W-07's parsers are:
 * `validateSearch` runs in the route module the router loads eagerly, so reading
 * `SECTIONS` from `settings-page.tsx` pulled the whole settings screen — its six
 * sections, the XLSX writer behind "Dışa aktar" — into the initial bundle.
 */
export const SECTIONS = [
  'company',
  'users',
  'currencies',
  'taxes',
  'categories',
  'units',
  'numbering',
  // design W-31a/b order: the warehouse chain, then the new stock section, then work centres
  'warehouses',
  'stock',
  'workCenters',
  // the money side: what the partners' capital costs (migration 20261002000001)
  'capitalCost',
  'amazon',
  'notifications',
  'shortcuts',
  'infra',
  'audit',
  'importExport',
  'backup',
] as const;
export type Section = (typeof SECTIONS)[number];

export interface SettingsSearch {
  s?: Section;
  /** The warehouse the Depolar section has open (W-31 §4). */
  w?: string;
}

export function parseSettingsSearch(s: Record<string, unknown>): SettingsSearch {
  return {
    s: (SECTIONS as readonly string[]).includes(s.s as string) ? (s.s as Section) : undefined,
    w: typeof s.w === 'string' && s.w ? s.w : undefined,
  };
}
